module.exports = "<span data-ng-message=required>*Threat probability is required.</span>";